/**
 * 안내(.notice)의 닫기(×) — [data-notice-close] 를 누르면 그 안내를 감춘다.
 *
 * 모달 footer 의 저장 결과 안내처럼 문구만 바뀌는 안내는 hidden 으로 감추고 두면
 * 다음 결과가 올 때 각 화면 모듈(setNotice)이 다시 보여 준다.
 * 안내가 화면 곳곳에 있고 나중에 만들어지기도 하므로 문서 한 곳에서 위임으로 받는다.
 * (Alpine 로 여닫는 /ui/ 예시나 자기 핸들러가 있는 화면은 data-notice-close 를 쓰지 않는다)
 */

const InitNotice = () => {
  document.addEventListener('click', (event) => {
    const close = event.target.closest?.('[data-notice-close]');
    const notice = close?.closest('.notice');

    if (!notice) {
      return;
    }

    notice.hidden = true;
  });
};

export default InitNotice;
